import * as CookieConsent from "vanilla-cookieconsent";

export function initCookieConsent() {

    const options = {
        guiOptions: {
            consentModal: {
                layout: 'cloud',
                position: 'bottom center',
                flipButtons: true,
                equalWeightButtons: false
            },
            preferencesModal: {
                layout: 'bar wide',
                // position: 'left right',
                flipButtons: false,
                equalWeightButtons: false
            }
        },

        onConsent: function () {
            // consent was given
        },

        onChange: function () {
            // user changed his/her preferences
        },

        categories: {
            necessary: {
                enabled: true,  // this category is enabled by default
                readOnly: true  // this category cannot be disabled
            },
            analytics: {
                enabled: false,
                readOnly: false,

                // Delete specific cookies when the user opts-out of this category
                autoClear: {
                    cookies: [
                        {
                            name: /^_ga/,   // regex: match all cookies starting with '_ga'
                        },
                        {
                            name: '_gid',   // string: exact cookie name
                        }
                    ]
                }
            }
        },
        language: {
            default: 'en',
            translations: {
                'en': '/content/cookieConsent-en.json'
            }
        }
    };
    CookieConsent.run(options);
}
export default initCookieConsent;